import {post} from '@/utils/request'
import axios from "axios";

const TARGET_SERVER = process.env.VUE_ENV === "server";
const baseUrl = process.env.config.RRDH_HOST;
export default {
    pageList: query => post('/rrbi/model/getWsPage', query),
    select: id => post('/rrbi/model/selectWs/' + id),
    userThreeModel: (userId, materialSort) => post('/rrbi/model/userThreeModel/' + userId + "/" + materialSort),
    updateCountNum: id => post('/rrbi/model/updateCountNum/' + id),
    updateDownloadCountNum: id => post('/rrbi/model/updateDownloadCountNum/' + id),


}

//服务器渲染  数据获取
export function fetchModelDetail({id, cookies}) {
    return axios.post(baseUrl + `/rrbi/model/selectWs/${id}`, {
        headers: getCommonHeader({cookies})
    });
}

//服务器渲染  数据获取
export function fetchNewIndexMakeList({id, cookies,params}) {
    return axios.post(baseUrl + `/rrbi/model/getWsPage`, params,{
        headers: getCommonHeader({ cookies })
    });
}


function getCommonHeader({cookies}) {
    if (TARGET_SERVER && cookies) {
        return {cookie: getCookieString(cookies)};
    } else {
        return null;
    }
}

function getCookieString(cookies) {
    let cookieStr = "";
    for (var variable in cookies) {
        if (Object.prototype.hasOwnProperty.call(cookies, "variable")) {
            cookieStr += `${variable}=${encodeURIComponent(cookies[variable])}; `;
        }
    }
    return cookieStr;
}
